export type ThemeId = 'light' | 'sepia' | 'dark' | 'midnight';
export const CANONICAL_THEMES: ThemeId[] = ['light', 'sepia', 'dark', 'midnight'];
export const THEME_STORAGE_KEY = 'bv-theme';
export const DEFAULT_THEME: ThemeId = 'light';

export function isCanonicalTheme(v: unknown): v is ThemeId {
  return typeof v === 'string' && (CANONICAL_THEMES as string[]).includes(v);
}

/** Resolve the initial theme from a (possibly malformed) saved value + OS preference.
 *  Pure + throw-safe: caller passes already-read values; this fn never throws. */
export function resolveInitialTheme(saved: unknown, prefersDark: boolean): ThemeId {
  if (isCanonicalTheme(saved)) return saved;
  return prefersDark ? 'dark' : DEFAULT_THEME;
}
